<template lang="pug">
b-modal#assignUserRole(
  ref="assignUserRole"
  :title="userId"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  body-class="p-0"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit" style="overflow: hidden scroll; height: 30vh;").p-0.m-0.xps
    b-list-group(flush)
      b-list-group-item(
        v-for="userRoleInfo in userRoleList"
        :data="userRoleInfo"
        :key="userRoleInfo.role_id"
        v-if="!loading"
        ).d-flex.flex-nowrap.px-3.py-2
        label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
          input.switch-input(type="checkbox" v-model="selectedRoles" :value="userRoleInfo.role_id")
          span.switch-slider(:data-checked='$t("ui.on")' :data-unchecked='$t("ui.off")')
        div.ml-3.align-self-center {{ userRoleInfo.role_name }}
  div.row
    div.col
      b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton
  },
  props: {
    userId: "",
    userName: ""
  },
  data() {
    return {
      userRoleList: [],
      selectedRoles: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  methods: {
    getUserRole() {
      this.userRoleList = [];
      let url = config.getUserRoleUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.user,
        user_id: this.userId
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.userRoleList = response.data.tbl_user_roles;

                for (var i = 0; i < this.userRoleList.length; i++) {
                  if (this.userRoleList[i].allow == 1) {
                    this.selectedRoles.push(this.userRoleList[i].role_id);
                  }
                }
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                // this.$emit("failed", "assign_roles", this.feedback.status);
                // this.$refs.assignUserRole.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      let url = config.addUserRoleUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.user,
        user_id: this.userId,
        role_id: this.selectedRoles.toString()
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.assignUserRole.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.selectedRoles = [];
      this.getUserRole();
    }
  }
};
</script>
